<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div >
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-body modal-content">
                            <div class="">
                                <div class="title_block">
                                    <h3 v-if="colorLabel" class="mb-0 font-active">
                                        {{ colorLabel }} : <span>{{ item }}</span>
                                    </h3>

                                    <span @click="notOpenModal">
                                        <SvgHeaderSvg type="close" class="largesvg"/>
                                    </span>
                                </div>
                                <div class="mt-3">
                                    <p class="mb-0">Diamond color refers to the absence of color within a diamond and is measured on a scale of D-Z, with D referring to the most colorless diamond and Z representing the least colorless diamond.</p>

                                    <div class="images my-3" ref="scrollContainer">
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/m.svg">
                                            <p :class="{ 'highlight': isHighlighted('M') }">M</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/l.svg">
                                            <p :class="{ 'highlight': isHighlighted('L') }">L</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/k.svg">
                                            <p :class="{ 'highlight': isHighlighted('K') }">K</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/j.svg">
                                            <p :class="{ 'highlight': isHighlighted('J') }">J</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/i.svg">
                                            <p :class="{ 'highlight': isHighlighted('I') }">I</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/h.svg">
                                            <p :class="{ 'highlight': isHighlighted('H') }">H</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/g.svg">
                                            <p :class="{ 'highlight': isHighlighted('G') }">G</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/f.svg">
                                            <p :class="{ 'highlight': isHighlighted('F') }">F</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/e.svg">
                                            <p :class="{ 'highlight': isHighlighted('E') }">E</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/d.svg">
                                            <p :class="{ 'highlight': isHighlighted('D') }">D</p>
                                        </div>
                                    </div>
                                        <!-- highlight vs1 & vs2 inplace of vs  sliders of inithorizontal-->
                                    <p class="mb-0">Our {{ $t('jewelry') }} features F-G color graded accent diamonds that appear colorless or near-colorless to the naked eye.</p>
                                </div>
                            </div>
                        </div>
                    </div>
            
                </div>
            </Teleport>
    </div>
</div>
</template>

<script setup>
const scrollContainer = ref('')
const startX = ref(0);
const isDown = ref(false)
const scrollLeft = ref(0);

const flagShowModal = ref(false);
const sideColor = ref(null);
const props = defineProps(['item','title','moduleSubType','currentMetal','type','detailData','complete','ringBox'])

const active = ref(props.ringBox)

    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
const emit = defineEmits(['close']);




const colorLabel = computed(() => {
    if (
        (props.moduleSubType === 'ring' || props.type === 'preset' || props.detailData === 'in-stock-ring' || props.detailData === 'ring' || props.complete === 'earring' || props.complete === 'pendant' ||
            props.complete === 'ring') && 
        !(['pendant', 'earring'].includes(props.moduleSubType)) && 
        !(props.detailData === 'band-ring' || 
            props.detailData === 'full-eternity-ring' || 
            props.detailData === 'anniversary-ring' || 
            props.detailData === 'toi-et-moi-ring' || 
            props.detailData === 'couple-bands-ring')
    ) {
        return 'Side Stone Color';
    } else if (
        props.detailData === 'band-ring' || 
        props.detailData === 'full-eternity-ring' || 
        props.detailData === 'anniversary-ring' || 
        props.detailData === 'toi-et-moi-ring' || 
        props.detailData === 'couple-bands-ring' || 
        props.detailData === 'tennis-bracelet' || 
        props.detailData === 'fashion-bracelet' || 
        props.detailData === 'fashion-earring' ||
        props.detailData === 'hoop-earring' || 
        props.detailData === 'solitaire-necklace' || 
        props.detailData === 'tennis-necklace' || 
        props.detailData === 'stud-earring'
    ) {
        return 'Average Color';
    } else if (['pendant', 'earring'].includes(props.moduleSubType)) {
        return 'Accent Stone Color';
    }
    return '';
});

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
            const modalElement = sideColor.value;
            if (modalElement) {
                const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
                modalElement.addEventListener('shown.bs.modal', () => {
                    scrollToHighlightedImage();
                });  
                initHorizontalScroll();
            }
        });
    };

    const hideModal = () => {
        const modalElement = sideColor.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };
    const colorRange = ref(props.item);

    const isHighlighted = (letter) => {
    let range = colorRange.value;
    if (typeof range === 'string') {
        range = range.split('-');
    }
    const upperRange = range.map(c => c.toUpperCase());
    return upperRange.includes(letter.toUpperCase());
    };

    const scrollToHighlightedImage = () => {
            const scroll_Container = scrollContainer.value;
            if (scrollContainer.value) {
                const highlightedElement = scroll_Container.querySelector('.highlight');
                if (highlightedElement) {
                    highlightedElement.scrollIntoView({ behavior: 'smooth', inline: 'start' });
                }
            }
        };

    function initHorizontalScroll() {
        if(scrollContainer.value){
            const scroll_Container = scrollContainer.value;

            scroll_Container.addEventListener('mousedown', (e) => {
                isDown.value = true;
                startX.value = e.pageX - scroll_Container.offsetLeft;
                scrollLeft.value = scroll_Container.scrollLeft;
    
            });

            scroll_Container.addEventListener('mouseleave', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mouseup', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mousemove', (e) => {
                if (!isDown.value) return;
                e.preventDefault();
                const x = e.pageX - scroll_Container.offsetLeft;
                const walk = (x - startX.value) * 3; // Adjust scrolling speed here
                scroll_Container.scrollLeft = scrollLeft.value - walk;
            });
        }
    }

    onMounted(() => {
        initHorizontalScroll();   
        scrollToHighlightedImage();
    })
    
    defineExpose({
        scrollToHighlightedImage,
    });
    
</script>



<style scoped>
.highlight {
    color: #668b84;
    font-weight: bold;
    text-decoration: underline;
  }

.largesvg {
    transform: scale(1.3);
    }

.images {
    display: flex;
    overflow-x: auto; 
    gap: 16px;
    align-items: center;
    cursor: pointer;
}

.images .box {
    flex: 0 0 auto; 
    width: auto; 
    text-align: center;
    user-select: none;
}

.pop_open {
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
}


p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}
.box{
 width: 25%;
}
.m-info {
    margin: 10px 0;
}


/* -----scroll--------- */
/* width */
.images::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  
  /* Track */
  .images ::-webkit-scrollbar-track {
    background: #f5f5f5; 
  }
   
  /* Handle */
  .images::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    cursor: pointer;
  }
  
  /* Handle on hover */

  /* -----scroll--------- */
@media(max-width: 767px) {
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }

}</style>
